import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
export default function RainCloudUmbrella({
  className,
  fillPrimary = colors.neutral100,
  fillSecondary = colors.aqua50,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="rain-cloud-umbrella 2" clipPath="url(#clip0_3811_2532)">
        <path
          id="Vector"
          d="M15.7539 18.0176C13.7383 18.136 11.7665 18.6556 9.95415 19.5458C8.14182 20.436 6.52538 21.679 5.19956 23.2019C3.87373 24.7248 2.86518 26.497 2.233 28.4146C1.60081 30.3322 1.35772 32.3568 1.51795 34.3696C1.49395 30.7276 8.29995 30.6996 8.32995 34.3696C9.23795 30.7276 15.5919 30.7276 16.4999 34.3696C17.4079 30.7276 23.7619 30.7276 24.6719 34.3696C24.6999 30.6996 31.5059 30.7276 31.4719 34.3696C31.5866 32.0631 31.2215 29.7579 30.3999 27.5996"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M16.5 34.3701V43.5001C16.5 44.2958 16.8161 45.0588 17.3787 45.6214C17.9413 46.184 18.7044 46.5001 19.5 46.5001C20.2956 46.5001 21.0587 46.184 21.6213 45.6214C22.1839 45.0588 22.5 44.2958 22.5 43.5001"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M28.124 22.5L30.964 17.834"
          stroke={fillSecondary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M34.124 22.5L37.124 17.916"
          stroke={fillSecondary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M28.57 11.6244C28.5233 11.2516 28.5 10.8762 28.5 10.5004C28.5026 9.93492 28.5595 9.37099 28.67 8.81641"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_6"
          d="M42.132 18.2182C43.4215 17.447 44.4975 16.3652 45.2617 15.0714C46.0258 13.7777 46.454 12.3133 46.507 10.8116C46.56 9.31001 46.2362 7.81901 45.5651 6.47462C44.8941 5.13024 43.8971 3.97526 42.6651 3.11503C41.4332 2.25481 40.0054 1.71671 38.5122 1.54983C37.0189 1.38294 35.5076 1.59258 34.1162 2.15961C32.7247 2.72665 31.4974 3.63304 30.5461 4.79611C29.5948 5.95918 28.9498 7.34191 28.67 8.81819C27.3856 8.2014 25.9147 8.09589 24.5554 8.52303C23.1961 8.95017 22.0499 9.87803 21.3491 11.1186C20.6483 12.3592 20.4453 13.8198 20.7812 15.2045C21.1171 16.5892 21.9667 17.7945 23.158 18.5762"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3811_2532">
          <rect width="48" height="48" fill={fillPrimary} />
        </clipPath>
      </defs>
    </svg>
  );
}
